import { render, staticRenderFns } from "./bidOpeningOpera.vue?vue&type=template&id=028703c6&scoped=true"
import script from "./bidOpeningOpera.vue?vue&type=script&lang=js"
export * from "./bidOpeningOpera.vue?vue&type=script&lang=js"
import style0 from "./bidOpeningOpera.vue?vue&type=style&index=0&id=028703c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028703c6",
  null
  
)

export default component.exports